if (!customElements.get("m-product-details-tabs")) {
  class MProductDetailsTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = new MinimogTheme.Tabs(this);

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const tabHeader = event && event.target;
          const index = (tabHeader && Number(tabHeader.dataset.index)) || 0;
          this.tabs && this.tabs.setActiveTab(index);
        });
      }
    }
  }
  customElements.define("m-product-details-tabs", MProductDetailsTabs);
}

  const videoTab = document.querySelector('.m-tab-content--liquid[data-block-type="liquid"]');

  if (videoTab) {
    const hasContent = videoTab.querySelector('.m-tab-content__inner').innerHTML.trim().length > 0;

    if (!hasContent) {
      videoTab.style.display = "none";
      const videoTabHeader = document.querySelector('.m-tab-header[data-block-type="liquid"]');
      if (videoTabHeader) {
        videoTabHeader.style.display = "none";
      }
    }
  }
